import styled from "styled-components"
import {Modal} from "react-bootstrap"

interface Props {
  maxWidth?: string
}

export const StyledModal = styled(Modal)<Props>`
  .modal-dialog {
    text-align: center;
    padding: ${({theme}) => theme.spacing.four};
    ${({maxWidth}) => maxWidth && `max-width: ${maxWidth};`}
    width: auto !important;
    margin: auto;
  }
  .modal-content {
    margin-top: 100px;
    padding: ${({theme}) => theme.spacing.eight};
  }
`

export const Img = styled.img`
  margin-top: -175px;
`
